import type { User } from '@repo-level/core-front';
import {
  factory,
  register as registerOriginal,
  snakify,
} from '@repo-level/core-front';
import type { UpdateFactoryParams } from '@repo-level/core-front/types/common';

export type RegistrationFormApi = Pick<User, 'email' | 'currency'> & {
  password: string;
  termsAgePromosAcceptance: boolean;

  receivePromos: boolean;
  receiveSmsPromos: boolean;
  receivePromosViaPhoneCalls: boolean;
  agreedToPartnerPromotions: boolean;
  receivePromosMain?: boolean; // tech field
};

type RegistrationFormApiParams = Omit<
  RegistrationFormApi,
  'termsAgePromosAcceptance'
> & {
  ageAcceptance?: boolean;
  termsAcceptance?: boolean;
  receivePromos?: boolean;
};

export const register =
  registerOriginal as UpdateFactoryParams<RegistrationFormApiParams>;

export const confirmationEmailPost = factory(
  (r) => (email: string) =>
    r<null>('post', 'users/confirmation', { user: { email } })
);

export const addPlayerGroups = factory(
  (r) => (groups: string[]) =>
    r<void>(
      'post',
      'player/groups',
      snakify({
        groups: { add: groups },
      })
    )
);

export interface IConnectedAuthProvider {
  id: number;
  type: string;
  active: boolean;
}

export const fetchConnectedAuthProviders = factory(
  (r) => () => r<IConnectedAuthProvider[]>('get', 'auth_providers')
);

export type AuthProviderDetailsApi = {
  profileAttributes: {
    country?: string;
    currency?: string;
    ageAcceptance?: boolean;
    termsAcceptance?: boolean;
    receivePromos?: boolean;
    receiveSmsPromos?: boolean;
    receivePromosViaPhoneCalls?: boolean;
    agreedToPartnerPromotions?: boolean;
  };
};

// Finishes an account created by an OAuth provider (Google) — the platform
// keeps such a player incomplete until these fields arrive.
export const updateAuthProviderDetails = factory(
  (r) => (user: AuthProviderDetailsApi) =>
    r<User>('post', 'auth_providers/update_details', snakify({ user }))
);
